import _ from "lodash";

interface Role {
  roleFilters: { [key: string]: string[] };
}

export const useMyHrFilterChange = ({
  role,
  onUpdateRole,
}: {
  role: Role;
  onUpdateRole: (role: Role) => void;
}) => {
  const handleAddFilter = (e: { key: string; value: string }) => {
    const newState = _.cloneDeep(role);
    newState?.roleFilters[e.key].push(e?.value);
    onUpdateRole(newState);
  };

  const handleRemoveFilter = (e: { key: string; value: string }) => {
    const newState = _.cloneDeep(role);
    const filtered = newState?.roleFilters[e.key].filter(
      (value) => value !== e.value,
    );
    newState.roleFilters[e.key] = filtered;
    onUpdateRole(newState);
  };

  return { handleAddFilter, handleRemoveFilter };
};

export default useMyHrFilterChange;
